module.exports = __webpack_public_path__ + "static/media/volume-high.95f1f2f3.svg";